module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/ntpc-90beffb9a2297af54d0113c3bd975c31.svg&quot;;"